// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"450":"3844b29b282958e29566","750":"379c7535b1c216330bf3"}[chunkId] + ".js";
};